import { combineReducers } from 'redux';
import { GridReducer } from './gridReducer'
import { AssignReducer } from './assignReducer';


export default combineReducers({
  grid: GridReducer,
  assign: AssignReducer
});
